import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10.388 7.078",
	width: 10,
	height: 7,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Icon - Tick",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M9.329 1.06 3.561 6.328l-2.5-2.5",
			"data-name": "Path 3966"
		})
	})
});
export { SvgTick as ReactComponent };
